import * as React from "react";
import DeviceContext from "./../../../service/indentifyDevice";
import OpLayout from "../opLayout/opLayout";
import OpQuotesEquityDsk from "../opQuotes/opQuotesEquity/opQuotesEquityDsk";
import OpQuotesEquityTab from "../opQuotes/opQuotesEquity/opQuotesEquityTab";
import OpQuotesEquityMob from "../opQuotes/opQuotesEquity/opQuotesEquityMob";
import { AGetQuotesNormal, AGetHoldingNormal } from "./../../../service/orderPlacement/opApiService";
import { IOpRouteParams } from "../../../types/components/orderPlacement/opTypes";
import { RouteChildrenProps } from "react-router-dom";

export interface IOpEquityContainerProps {}

export interface IOpEquityContainerState {
	quoteData: any;
	holdingData?: any;
}

class OpEquityContainer extends React.Component<IOpEquityContainerProps & RouteChildrenProps<IOpRouteParams>, IOpEquityContainerState> {
	state: IOpEquityContainerState = { quoteData: {} };
	quoteComp: any;

	getQuotesRes = (res: any) => {
		if (res.data) {
			this.setState({ quoteData: res.data });
		}
	};
	
	getHoldingRes = (res: any) => {
		if (res.data) {
			this.setState({ holdingData: res.data });
		}
	};

	componentDidMount() {
		AGetQuotesNormal(this.getQuotesRes, this.props.match?.params.sym!);
		AGetHoldingNormal(this.getHoldingRes, this.props.match?.params.sym!);
	}

	render() {
		this.quoteComp = DeviceContext().isDesktop ? (
			<OpQuotesEquityDsk quoteData={this.state.quoteData} holdingData={this.state.holdingData} />
		) : DeviceContext().isTablet ? (
			<OpQuotesEquityTab quoteData={this.state.quoteData} holdingData={this.state.holdingData} />
		) : (
			<OpQuotesEquityMob quoteData={this.state.quoteData} holdingData={this.state.holdingData} />
		);
		return <OpLayout quoteComp={this.quoteComp} />;
	}
}

export default OpEquityContainer;
